// DS: DS6.1 - Button Semantics
import React from 'react';
import omit from 'lodash/omit';
import { CommonListItemAPI, EffectStrength, useListItem } from '../../common';
import { setRef } from '../../../../../utils/refHelpers';
import PlainButtonOrLink, {
  type Props as PlainButtonOrLinkProps,
} from '../../../../Buttons/PlainButtonOrLink';
import ListItemContent from '../../legos/ListItemContent';

export interface Props
  extends Omit<PlainButtonOrLinkProps, 'prefix' | 'disabled' | 'innerRef'>, CommonListItemAPI {}

const ListItemButton: React.FC<Props> = unfilteredProps => {
  const {
    rootProps: { ...rest },
    contentProps,
    ref,
  } = useListItem<HTMLButtonElement, Props>(unfilteredProps, {
    hover: EffectStrength.Strong,
  });

  return (
    <PlainButtonOrLink innerRef={node => setRef(ref, node)} {...omit(rest, 'checked')}>
      <ListItemContent {...contentProps} />
    </PlainButtonOrLink>
  );
};

ListItemButton.displayName = 'ListItemButton';

export default ListItemButton;
